import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { Link as DomLink } from 'react-router-dom';
import { FormControlLabel } from '@mui/material';
import Typography from '@mui/material/Typography';

export const FOREFLIGHT_BLUE = '#3598da';

export const StyledTextField = styled(TextField, {
    shouldForwardProp: prop => prop !== 'hidden',
})<{ hidden?: boolean }>(({ hidden }) => ({
    display: hidden ? 'none' : 'block',

    '& .MuiInputBase-root': {
        color: 'white',
        background: 'transparent',
    },

    '& .MuiInputLabel-root': {
        color: 'gray !important',
        transform: 'translate(0, -5px) scale(1)',
        fontSize: '16px',
    },

    '& .MuiInput-underline:before': {
        borderBottom: '2px solid gray !important',
    },

    '& .MuiInput-underline:hover:before': {
        borderBottom: '2px solid white !important',
    },

    '& .MuiInput-underline:after': {
        borderBottom: '2px solid #4a90e2 !important',
    },

    // Fix autofill background color issue
    '& input:-webkit-autofill': {
        backgroundColor: 'transparent !important',
        WebkitBoxShadow: '0 0 0px 1000px transparent inset !important',
        WebkitTextFillColor: 'white !important',
        transition: 'background-color 5000s ease-in-out 0s',
    },
}));

export const LoginWrap = styled('div')`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
`;

export const CenteredContainer = styled('div')`
    height: 520px;
    width: 100%;
    max-width: 500px;
    padding: 0 16px;
    box-sizing: border-box;
`;

export const Link = styled(DomLink)<{ fontSize?: string }>`
    color: #4a90e2;
    text-decoration: none;
    font-size: ${({ fontSize }) => (fontSize != null ? fontSize : '12px')};
`;

export const StyledCheckbox = styled(FormControlLabel)`
    .MuiCheckbox-root {
        color: #888;
    }
    .Mui-checked {
        color: ${FOREFLIGHT_BLUE} !important;
    }
    .MuiFormControlLabel-label {
        color: #cccccc;
        font-size: 12px;
    }
`;

export const Email = styled(Typography)`
    font-weight: 100;
    font-size: 17px;
    text-align: center;
`;
